// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:587px){.cpj-index_featureLogo .swiper-wrapper{align-items:center}.cpj-index_featureLogo img{height:auto;max-height:90px}}", ""]);
// Exports
module.exports = exports;
